<div class="grid-container padding-y-4">
  @if (frtPackageDetailsCalledFrom != 'frtBOL') {
    <div>
      <div>
        <legend class="usa-legend usa-legend--medium">PACKAGE INFORMATION</legend>
        <h5 >Estimated Shipment Weight : {{estimatedWeight}}</h5>
        @if (!noOfFleetVehicles) {
          <h5>Estimated Shipment Cu ft : {{estimatedCubic}}</h5>
        }
        @if (noOfFleetVehicles) {
          <h5>No. of Fleet Vehicles : {{noOfFleetVehicles}}</h5>
        }
      </div>
      <form [formGroup]="frtPackageInfoForm">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="totalPieces" class="usa-label text-bold">Total Pieces
              <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
            </label>
            <input type="text" id="totalPieces" class="usa-input maxw-full" formControlName="totalPieces"
              maxlength="5" appNumbersOnly onkeypress="return !(event.charCode == 46)" step="1">
            @if ( this.frtPackageInfoForm.get('totalPieces').touched && this.frtPackageInfoForm.get('totalPieces').hasError('totalPieceErr')) {
              <small class="define-text-secondary">
                Exceed number of total pieces
              </small>
            }
            @if ( this.frtPackageInfoForm.get('totalPieces').touched && this.frtPackageInfoForm.get('totalPieces').hasError('min')) {
              <small class="define-text-secondary">
                Must be a positive number
              </small>
            }
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="noOfLoosePieces" class="usa-label text-bold">
              No. of Loose Pieces
            </label>
            <input type="text" id="noOfLoosePieces" class="usa-input maxw-full"
              formControlName="noOfLoosePieces" maxlength="5" appNumbersOnly
              onkeypress="return !(event.charCode == 46)" step="1">
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="packageType" class="usa-label text-bold">Package Type
              <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
            </label>
            <select formControlName="packageType" class="maxw-full usa-select" (change)="onPackageTypeChange()"
              id="packageType">
              <option [ngValue]="null">Choose...</option>
              @for (packageType of shipmentPackageTypes; track packageType) {
                <option [ngValue]="packageType.packageTypeId">
                {{packageType.packageDescription}}</option>
              }
            </select>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="freightCommodityDesc" class="usa-label text-bold">
              Freight Commodity Description<abbr title="required" class="usa-hint usa-hint--required">*</abbr>
            </label>
            <input type="text" id="freightCommodityDesc" class="usa-input maxw-full"
              formControlName="freightCommodityDesc" maxlength="100">
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="weight" class="usa-label text-bold">
              Weight(Pounds Only)<abbr title="required" class="usa-hint usa-hint--required">*</abbr>
            </label>
            <input (change)="onWeightChange()" type="text" id="weight" class="usa-input maxw-full"
              formControlName="weight" maxlength="5" appNumbersOnly
              onkeypress="return !(event.charCode == 46)" step="1">
            @if (overWeight) {
              <small class="define-text-secondary">
                Total Weight cannot be higher than the Estimated Shipment Weight.
              </small>
            }
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="cube" class="usa-label text-bold">
              Cu ft@if (validateCuFt) {
              <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
            }
          </label>
          <input (change)="onCubicChange()" type="text" id="cube" class="usa-input maxw-full"
            formControlName="cube" maxlength="5" appNumbersOnly onkeypress="return !(event.charCode == 46)"
            step="1">
          @if (overCubic) {
            <small class="define-text-secondary">
              Total Cubic Feet cannot be higher than the Estimated Shipment Cubic Feet.
            </small>
          }
        </div>
        <!--   sy code begin to add truck num-->
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="packageType" class="usa-label text-bold">Truck Num
          </label>
          <select formControlName="truckNum" class="maxw-full usa-select" (change)="onTruckNumChange()"
            id="truckNum">
            @for (trucknum of [1,2,3,4,5,6,7,8,9]; track trucknum) {
              <option [ngValue]="trucknum">Truck Num {{trucknum}}
              </option>
            }
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="chargebleCode" class="usa-label text-bold"> Appropriation Chargable Code</label>
              <select id="chargebleCode" multiple class="define-height-usa-select usa-select maxw-full"
                formControlName="appChargeCodes" title="Available Charge Codes" name="appChargeCodeList"
                aria-label="Select from available Appropriation Charge Codes">
                <option value='null'>-Select Appropriation Chargable Code(s)-</option>
                @for (appchargeCode of avaiAppropriationChargeCodes; track appchargeCode) {
                  <option
                    [value]="appchargeCode.chargeCode">
                    {{appchargeCode.chargeCode}}
                  </option>
                }
              </select>
            </div>
            <div
              class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-1 desktop:grid-col-1 text-center define-margin-x-y-auto">
              <button type="button" class="usa-button usa-button--hover width-full" (click)="moveItems()">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
                </svg>
              </button>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="assigned_rate_type" class="usa-label text-bold">Assigned Appropriation Charge
              Codes</label>
              <select multiple id="assigned_rate_type" formControlName="assignedChargeCodes"
                class="define-height-usa-select usa-select maxw-full">
                @for (assginedChargeCode of assignedAppropriationChargeCodes; track assginedChargeCode; let i = $index) {
                  <option
                    [value]="assginedChargeCode.chargeCode"
                    (dblclick)="handleRateTypesMultiDropdown(i)">
                    {{assginedChargeCode.chargeCode}} - {{assginedChargeCode.chargeCode}}
                  </option>
                }
              </select>
              <div style="font-weight: 700;">Double click on item to remove from this list.</div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="otherChargebleCode" class="usa-label text-bold">Other Appropriation Chargable
              Code</label>
              <input type="text" id="otherChargebleCode" class="usa-input maxw-full"
                formControlName="otherChargebleCode" maxlength="100">
            </div>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <label for="addtinfo" class="usa-label text-bold">Additional information
            @if (addInfoRequired) {
              <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
            }
          </label>
          <textarea id="addtinfo" rows="5" class="maxw-full usa-textarea" formControlName="addtinfo"
          maxlength="250"></textarea>
        </div>
      </div>
    </form>
    <div class="grid-row grid-gap-1 margin-top-4">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        @if (!carrierUser) {
          <button type="button" class="usa-button" [disabled]="!(frtPackageInfoForm.valid && !packageClicked)"
          (click)="onSaveOrEditClicked('save')">Save</button>
        }
        @if (!carrierUser) {
          <button type="button" class="usa-button  margin-left-2"
            [disabled]="!(frtPackageInfoForm.valid && packageClicked && frtPackageInfoForm.dirty)"
          (click)="onSaveOrEditClicked('update')">Update</button>
        }
        @if (!carrierUser) {
          <button type="button" class="usa-button  margin-left-2" [disabled]="!packageClicked"
          (click)="onDeleteClicked()">Delete</button>
        }
        @if (!carrierUser) {
          <button type="button" class="usa-button  margin-left-2"
          [disabled]="!packageClicked" (click)="openAddEditItem()">ADD ITEM</button>
        }
        @if (!carrierUser) {
          <button type="button" class="usa-button usa-button--outline  margin-left-2"
            [disabled]="!(frtPackageInfoForm.touched || frtPackageInfoForm.dirty || packageClicked)"
          (click)="onResetClicked()">Reset</button>
        }
        @if (!carrierUser) {
          <button type="button" class="usa-button usa-button--outline  margin-left-2"
          (click)="onManageChargeCodeClicked()">Manage Charge Codes</button>
        }
      </div>
    </div>
    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        @if (carrierUserOrBOL) {
          <label class="usa-label">
            Note: click on the "Select Package" link below to view Items of that Package
          </label>
        }
        @if (!carrierUserOrBOL) {
          <label class="usa-label">
            Note: To Edit Package Details click on the "Select Package" link below.
            To Add an Item to a Package, Please Add a Package First Or Select an Existing Package.
          </label>
        }
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <ag-grid-angular class="ag-theme-alpine maxw-full" [rowData]="packageAddedRowData"
          [gridOptions]="packageInfoGridOptions" [columnDefs]="packageAddedColumnDefs">
        </ag-grid-angular>
      </div>
    </div>
    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <button type="button" class="usa-button" (click)="onContinueClicked()">Continue</button>
      </div>
    </div>
  </div>
} @else {
  <div class="grid-row grid-gap-1">
    @if (noPackages) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12"
        >
        <h3>No Packages to Display</h3>
      </div>
    } @else {
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <label class="usa-label">
            Note: click on the "Select Package" link below to view Items of that Package
          </label>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <ag-grid-angular class="ag-theme-alpine maxw-full" [rowData]="packageAddedRowData"
            [gridOptions]="packageInfoGridOptions" [columnDefs]="packageAddedColumnDefs">
          </ag-grid-angular>
        </div>
      </div>
    }
  </div>
}
</div>